module.exports = __webpack_public_path__ + "static/media/cspl-team.b83a788a.png";